import { Injectable } from '@angular/core';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  private messaging;

  constructor() {
    const app = initializeApp(environment.firebase);
    this.messaging = getMessaging(app);
  }

  async requestPermissionAndGetToken(): Promise<string | null> {
    try {
      if (!("Notification" in window)) {
        console.error("Notifications are not supported.");
        return null;
      }

      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.error('Permission not granted');
        return null;
      }

      // ✅ get existing registration instead of always registering
      let registration = await navigator.serviceWorker.getRegistration(
        '/firebase-messaging-sw.js'
      );

      if (!registration) {
        registration = await navigator.serviceWorker.register(
          '/firebase-messaging-sw.js'
        );
      }

      const token = await getToken(this.messaging, {
        vapidKey: environment.firebase.vapId,
        serviceWorkerRegistration: registration
      });

      // console.log('FCM WEB TOKEN:', token);
      return token;

    } catch (error) {
      console.error('Error in token generation:', error);
      return null;
    }
  }
}